import { useAdminStatus } from '../../hooks/useAdmin'
import { STATUS_LABELS } from '../../constants/taxonomy'
import type { ContactStatus } from '../../types/contact'

function StatCard({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white px-5 py-4">
      <p className="text-xs font-medium text-gray-500">{label}</p>
      <p className="mt-1 text-2xl font-bold text-gray-900">{value}</p>
    </div>
  )
}

export default function AdminOverviewPage() {
  const { data, isLoading, isError } = useAdminStatus()

  if (isLoading) return <p className="text-sm text-gray-500">Loading platform status…</p>
  if (isError || !data) return <p className="text-sm text-red-600">Failed to load platform status.</p>

  return (
    <div>
      <h1 className="text-lg font-semibold text-gray-900 mb-4">Platform status</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <StatCard label="Total users" value={data.total_users} />
        <StatCard label="Reports (24h)" value={data.total_reports_24h} />
        <StatCard label="Total contacts" value={data.total_contacts} />
      </div>

      <h2 className="text-sm font-semibold text-gray-900 mt-6 mb-2">Contacts by status</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {Object.entries(data.contacts_by_status).map(([status, count]) => (
          <StatCard
            key={status}
            label={STATUS_LABELS[status as ContactStatus] ?? status}
            value={count}
          />
        ))}
      </div>
    </div>
  )
}
